import { format } from "date-fns";

/**
 * Walk-up resources have no reservation window, only the check-in matters.
 *
 * Takes already-parsed `Date`s rather than raw timestamp strings — unlike
 * `schedule.start`/`end` (a trailing `Z` but actually wall-clock time),
 * `check_in_time` is a real UTC instant, so the two fields this function
 * gets called with need different parsing. Pushing that decision to each
 * call site avoids guessing which convention applies here.
 *
 * `now` must be computed the same way as `checkInTime` (e.g. both passed
 * through `toZonedTime(_, officeTimeZone)`) — comparing against date-fns'
 * own `isToday()` would use the *viewer's* device timezone for "today",
 * which can disagree with the office's, wrongly adding or dropping the
 * date suffix even though the hour itself is correct.
 */
export function formatWalkUpOccupancy(
  checkInTime: Date | null,
  now: Date
): string {
  if (!checkInTime) {
    return "Currently occupied";
  }
  const isSameOfficeDay =
    checkInTime.getFullYear() === now.getFullYear() &&
    checkInTime.getMonth() === now.getMonth() &&
    checkInTime.getDate() === now.getDate();
  return `Occupied since ${format(checkInTime, isSameOfficeDay ? "hh:mm aa" : "hh:mm aa, MMM d")}`;
}
